import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import * as React from 'react'

import { useLoc } from "../../../hooks/useLoc"
import getLocationPath from '../../../services/getLocationPath';
import { CountryBase } from '../../../templates/fragments/country';
import { RegionStub } from '../../../templates/fragments/region';
import { Accordion } from '../../shared/base/accordion';

export const MobileFooter = ({ bestCountries, bestRegions }: { bestCountries: CountryBase[], bestRegions: RegionStub[] }) => {
    const loc = useLoc();

    return (<>
        <hr className="w-full mt-20"></hr>
        <div className="px-8 mt-5">
            <FooterAccordion title={loc('footer.aboutSunheron.title')}>
                <LinkItem to={'/about-us/'} text={loc('footer.aboutSunheron.aboutUs')}></LinkItem>
                <LinkItem to={'/privacy-policy/'} text={loc('footer.aboutSunheron.privacyPolicy')}></LinkItem>
                <LinkItem to={'/cookie-policy/'} text={loc('footer.aboutSunheron.cookiePolicy')}></LinkItem>
                <LinkItem to={'/faq/'} text={'FAQ'}></LinkItem>
                <LinkItem to={'/contact/'} text={loc('footer.aboutSunheron.contact')}></LinkItem>
            </FooterAccordion>
            <FooterAccordion title={loc('footer.topCountries')} >
                {bestCountries.slice(0, 10).map(country => (
                    <LinkItem key={country.slug} to={getLocationPath({ location: country, isCountryInstance: true, monthIndex: 12 })} text={country.name}></LinkItem>
                ))}
            </FooterAccordion>
            <FooterAccordion title={loc('footer.topDestinations')} >
                {bestRegions.slice(0, 10).map(country => (
                    <LinkItem key={country.slug} to={getLocationPath({ location: country, isCountryInstance: true, monthIndex: 12 })} text={country.name}></LinkItem>
                ))}
            </FooterAccordion>

            <hr className="mb-10 mt-6"></hr>
            <div className="text-zinc-500 opacity-80 text-sm pb-8">
                <div className="mb-4 text-center ts:text-left">
                    <OutboundLink href="https://www.facebook.com/sunheronweather" target="_blank">
                        <span className="">Facebook</span>
                    </OutboundLink>
                </div>
                <div className="mb-4 text-center ts:text-left">
                    <OutboundLink href="https://www.instagram.com/sunheron/" target="_blank">
                        <span className="">Instagram</span>
                    </OutboundLink>
                </div>
                <p className="flex-1 text-center">
                    {loc('footer.reservedRights')}
                </p>
            </div>
        </div>
    </>)

}

const LinkItem = ({ to, text }) => {
    return (
        <div className="pb-4"><Link to={to}>{text} </Link></div>
    )
}

const FooterAccordion = ({ title, children }) => {
    return (
        <Accordion title={title} className="py-5 pr-2 text-lg font-b">
            <div className='text-zinc-500 opacity-60 text-sm'>
                {children}
            </div>
        </Accordion>
    );
}